module.exports = __webpack_public_path__ + "img/knue_thumbnail.691f1c4b.jpg";